import { render, staticRenderFns } from "./RecordListModal.vue?vue&type=template&id=245b3739"
import script from "./RecordListModal.vue?vue&type=script&lang=js"
export * from "./RecordListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245b3739')) {
      api.createRecord('245b3739', component.options)
    } else {
      api.reload('245b3739', component.options)
    }
    module.hot.accept("./RecordListModal.vue?vue&type=template&id=245b3739", function () {
      api.rerender('245b3739', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecordControl/Modal/RecordListModal.vue"
export default component.exports